import React, { useEffect, useState } from "react";
import { useRecoilValue } from "recoil";
import { firstReceiptFormState } from "../../recoil/receipt";
import { getArea, getOverseasExperience, getBankName } from "../../static";
import StepBar2 from "../atoms/layout/StepBar2";
import { ReceiptStep } from "./ReceiptRouter";

const CompleteConfirm = ({ visibility }) => {
  const firstReceiptForm = useRecoilValue(firstReceiptFormState);
  const [isShowConfirm, setIsShowConfirm] = useState(true);

  useEffect(() => {
    if (visibility === true) {
      setTimeout(() => {
        setIsShowConfirm(false);
      }, 3000);
    }
  }, [visibility]);

  return (
    <div style={{ display: visibility }}>
      <div className="base-top flex">
        <div className="koica_logo">
          <img
            src="../../../../img/khcp/khcp_ko.png"
            style={{width: "162.3px", height: "auto"}}
          />
        </div>
        <div>
          <img
            src="../../../../img/koica/SLI_LOGO.png"
            style={{ width: "162.3px", height: "67.6px" }}
          />
        </div>
      </div>
      <div className="base-sec">
        <div className="background-color-w">
          <div className="base-sec-top flex">
            <div>
              <p className="title">영어 말하기 평가</p>
            </div>
          </div>
          <div className="base-sec-sec complete-confirm-sec">
            <div className="page-title text-align-center">
              <p>작성완료</p>
            </div>
            {/* <StepBar2 step={ReceiptStep.SURVEY_DONE} /> */}
            <StepBar2 step={3} />

            {isShowConfirm && (
              <div className="complete-alert">
                [KHNP 영어 말하기 모의 평가]에 접수해 주셔서 대단히
                감사드립니다.
              </div>
            )}
            <div className="complete-table-box">
              <span style={{ color: "gray", margin: 10 }}>
                시험 접수 후에는 입력하신 이메일로 시험 안내 메일이 발송됩니다.
                <br />
              </span>
              <span style={{ color: "gray", margin: 10 }}>
                시험 안내 메일은 관리자가 개인별 접수 내용을 확인 후 발송해
                드립니다. 안내 메일은 접수일을 기준으로 1일 정도 소요됩니다.
              </span>
              <table style={{ color: "gray", margin: 10 }}>
                <caption>신청자 정보입력</caption>
                <tr>
                  <th>이름</th>
                  <td>{firstReceiptForm.name}</td>
                </tr>
                <tr>
                  <th>이메일</th>
                  <td>{firstReceiptForm.email}</td>
                </tr>
                <tr>
                  <th>전화번호</th>
                  <td>{firstReceiptForm.tel}</td>
                </tr>
                <tr>
                  <th>생년월일</th>
                  <td>{firstReceiptForm.birthday_YMD}</td>
                </tr>
                <tr>
                  <th>소속기관</th>
                  <td>{firstReceiptForm.company}</td>
                </tr>
              </table>
              <table style={{ color: "gray", margin: 10 }}>
                <caption>기타 정보입력</caption>
                {/* <tr>
                  <th>등급</th>
                  <td>
                    {firstReceiptForm.grade === "1" &&
                      "AL(Advanced Low) 상급"}
                    {firstReceiptForm.grade === "2" &&
                      "IH(Intermediate High) 중상급"}
                    {firstReceiptForm.grade === "3" &&
                      "IM(Intermediate Mid) 중급"}
                    {firstReceiptForm.grade === "4" &&
                      "IL(Intermediate Low) 초급"}
                    {firstReceiptForm.grade === "5" &&
                      "NH(Novice High이하) 기초"}
                  </td>
                </tr> */}
                <tr>
                  <th>성별</th>
                  <td>
                    {firstReceiptForm.gender === "1"
                      ? "남"
                      : firstReceiptForm.gender === "2" && "여"}
                  </td>
                </tr>
                {/* <tr>
                  <th>연령</th>
                  <td>{firstReceiptForm.age_band}</td>
                </tr> */}
                {/* <tr>
                  <th>거주지역</th>
                  <td>{getArea(parseInt(firstReceiptForm.residence))}</td>
                </tr> */}
                {/* <tr>
                  <th>해외경험</th>
                  <td>
                    {getOverseasExperience(
                      parseInt(firstReceiptForm.overseas_experience)
                    )}
                  </td>
                </tr> */}
              </table>
              {/* <table>
                <caption>전자서명</caption>
                <tr>
                  <th>개인인정보동의</th>
                  <td>ㅇㅇㅇ</td>
                </tr>
                <tr>
                  <th>서명</th>
                  <td>
                    ㅇㅇㅇ
                    <img src="img/icon_clip.svg" alt="클립" />
                  </td>
                </tr>
              </table> */}
            </div>
          </div>
          <div className="base-sec-bottom">
            {/*<button className="bottombtn bottombtn-b">다음</button>*/}
          </div>
        </div>
      </div>
    </div>
  );
};

export default CompleteConfirm;
